import { formatDuration } from '../format';
import { Button, Status } from '../ui';
import { useCall } from './CallContext';
import { callDockPresentation } from './callPresentation';

export function CallDock({ conversationId, liveVoiceStatus }: { conversationId: string | undefined; liveVoiceStatus: string | null }) {
  const call = useCall();
  const presentation = callDockPresentation(call.status, liveVoiceStatus);
  return <aside className={`call-dock ${presentation.active ? 'call-dock--active' : ''}`} aria-label="شريط المكالمة">
    <div className="call-dock__state">
      <Status tone={presentation.tone}>{presentation.label}</Status>
      {presentation.active ? <strong dir="ltr">{formatDuration(call.elapsedMs)}</strong> : null}
      {call.recording !== 'off' ? <span className="record-state">● {call.recording === 'recording' ? 'يُسجّل' : call.recording === 'uploading' ? 'رفع التسجيل متأخر' : call.recording === 'complete' ? 'اكتمل التسجيل' : 'التسجيل غير مكتمل'}</span> : null}
    </div>
    {call.error ? <p className="call-dock__error" role="alert">{call.error}</p> : null}
    <div className="call-dock__actions">
      {!presentation.active ? <Button disabled={!conversationId || !presentation.canStart} onClick={() => void call.start(conversationId ? { conversationId } : {})}>بدء مكالمة</Button> : <>
        <Button variant={call.muted ? 'danger' : 'secondary'} onClick={call.toggleMute}>{call.muted ? 'فتح الميكروفون' : 'كتم الميكروفون'}</Button>
        <Button variant="secondary" onClick={call.toggleSpeaker}>{call.speakerMuted ? 'تشغيل صوت رامي' : 'إسكات رامي محليًا'}</Button>
        <Button variant="secondary" onClick={call.toggleRecording}>{call.recording === 'recording' ? 'إيقاف التسجيل' : 'حالة التسجيل'}</Button>
        <Button variant="danger" busy={call.status === 'ending'} onClick={() => void call.end()}>إنهاء</Button>
      </>}
    </div>
  </aside>;
}
